import axiosInstance from "@/libs/axios_config";
import { setBypassMaintenance, setMaintenanceMode } from "@/storage/maintenance/maintenanceSlice";
import { RootState } from "@/storage/store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import AceScholarshipsLogo from '@assets/AceScholarshipLogo1.jpg'
import { useTranslation } from "react-i18next";

const MaintenancePage = () => {
    const dispatch = useDispatch()
    const { t: translate } = useTranslation()
    const { title, message, isOnMaintenance } = useSelector((state: RootState) => state.Maintenance)
    let didInit = false

    const checkMaintenanceStatus = () => {
        axiosInstance.get("/maintenance")
            .then(result => {
                const data = result.data
                const maintenance_mode = data.maintenance_mode
                if (! maintenance_mode && isOnMaintenance) {
                    dispatch(setBypassMaintenance(false))
                    dispatch(setMaintenanceMode(false))
                }
            }).catch(() => {
                if (isOnMaintenance) {
                    dispatch(setBypassMaintenance(false))
                    dispatch(setMaintenanceMode(false))
                }
            })
    }

    useEffect(() => {
        if (! didInit) {
            didInit = true
            checkMaintenanceStatus()
        }
    }, [])

    if (! isOnMaintenance) return <Navigate to={'/login'} />

    return (
        <div className="bg-muted-white flex flex-1 flex-col justify-center sm:px-6 lg:px-8 mx-auto w-full max-w-xl">
            <div
                className="bg-white px-10 py-5 border border-gray-50 sm:rounded-lg sm:shadow-md flex flex-col">
                <img
                    alt={translate('ace_logo')}
                    className="mx-auto h-auto"
                    src={AceScholarshipsLogo}
                />
                <h3 className="text-xl font-semibold text-gray-900 text-center mt-10 mb-4">
                    {title}
                </h3>
                <div className="text-md text-gray-500 font-medium text-center mb-7">
                    {message}
                </div>
            </div>
        </div>
    )
}

export default MaintenancePage;
